import { ColumnMetadata, RowSize, RowSizes } from "./types";
import { PaginationState } from "~/modules/filters/types";
import { DataGridRow } from "./DataGridRow";
import { Emdash } from "../Punctuation";

// // // //

export function DataGridDummyRows<RowType, SortableColumns>(props: {
    rows: RowType[];
    columns: ColumnMetadata<RowType, SortableColumns>[];
    paginationState: PaginationState;
    bordered: boolean;
    size: RowSize;
    analyticsTableName: string;
}) {
    const {
        rows,
        columns,
        paginationState,
        bordered,
        size,
        analyticsTableName,
    } = props;

    const dummyRows: Array<{ id: string }> = [];

    // Return null if there are no dummy rows to render
    if (!(rows.length < paginationState.perPage)) {
        return null;
    }

    for (let index = rows.length; index < paginationState.perPage; index++) {
        dummyRows.push({ id: `${analyticsTableName}-dummy-row-${index}` });
    }

    return (
        <>
            {dummyRows.map((dumdum, idx) => (
                <DataGridRow
                    row={dumdum}
                    // NOTE - this has been modified not to support extraSmall
                    // size={size}
                    size={size === RowSizes.extraSmall ? RowSizes.small : size}
                    key={dumdum.id}
                    bordered={bordered}
                    striped={(rows.length + idx) % 2 === 1}
                    columns={columns.map((c) => {
                        return {
                            ...c,
                            // Strip out data-dependent fields of each column
                            cellColor: undefined,
                            render: () => {
                                return (
                                    <Emdash className="invisible select-none" />
                                );
                            },
                        } as ColumnMetadata<{ id: string }, any>;
                    })}
                />
            ))}
        </>
    );
}
